import { render, staticRenderFns } from "./ProgressView.vue?vue&type=template&id=01b2c2aa&scoped=true&"
import script from "./ProgressView.vue?vue&type=script&lang=js&"
export * from "./ProgressView.vue?vue&type=script&lang=js&"
import style0 from "./ProgressView.vue?vue&type=style&index=0&id=01b2c2aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b2c2aa",
  null
  
)

export default component.exports